// extracted by mini-css-extract-plugin
export default {"main_background":"Main_main_background__pG9t2","title":"Main_title__-A84M","title_second":"Main_title_second__azIEn","span":"Main_span__c5IPP"};